export default __webpack_public_path__ + "static/media/ecosystem-exchange.04bc1960.png";